// extracted by mini-css-extract-plugin
export default {"container":"carousel_container__DgbFc","slides":"carousel_slides__v7JUP","slider":"carousel_slider__+Dadr"};